import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=2f70f61e&scoped=true&"
import script from "./Congratulations.vue?vue&type=script&lang=js&"
export * from "./Congratulations.vue?vue&type=script&lang=js&"
import style0 from "./Congratulations.vue?vue&type=style&index=0&id=2f70f61e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70f61e",
  null
  
)

export default component.exports